var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationPinAlt1SvgrepoCom({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "location-pin-alt-1-svgrepo-com (1) 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.0013 22.75C16.793 18.85 20.5846 15.3578 20.5846 11.05C20.5846 6.74218 17.1895 3.25 13.0013 3.25C8.81315 3.25 5.41797 6.74218 5.41797 11.05C5.41797 15.3578 9.20964 18.85 13.0013 22.75Z",
    stroke: "#040404",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.9987 12.9993C14.1953 12.9993 15.1654 12.0293 15.1654 10.8327C15.1654 9.63606 14.1953 8.66602 12.9987 8.66602C11.802 8.66602 10.832 9.63606 10.832 10.8327C10.832 12.0293 11.802 12.9993 12.9987 12.9993Z",
    stroke: "#040404",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationPinAlt1SvgrepoCom);
export default __webpack_public_path__ + "static/media/location-pin-alt-1-svgrepo-com.9d750f56edc2eae7827f0367864cc422.svg";
export { ForwardRef as ReactComponent };